import { ActionType, getType } from 'typesafe-actions'
import { IEntityHashMap } from 'flux-entities'

import * as actions from './actions'
import { IHospitalsState, createInitialHospitalsState } from './types'
import { IHospital } from '../../types/hospital'

type TAction = ActionType<typeof actions>

const initialHospitalsState = createInitialHospitalsState()

const hospitalsReducer = (state = initialHospitalsState, action: TAction): IHospitalsState => {
  switch (action.type) {
    case getType(actions.hospitalsError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.hospitalsRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.hospitalsSuccess): {
      const all: IEntityHashMap<IHospital> = {}
      const ids: number[] = []

      for (const hospital of action.payload) {
        if (!all[hospital.id]) {
          ids.push(hospital.id)
          all[hospital.id] = hospital
        }
      }

      return {
        all,
        ids,
        touched: true,
        loading: false,
        errors: [],
      }
    }

    case getType(actions.hospitalUpdateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.hospitalUpdateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.hospitalUpdateSuccess): {
      return {
        ...state,
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: [],
      }
    }
  }

  return state
}

export {
  hospitalsReducer,
  initialHospitalsState
}
